import { render, staticRenderFns } from "./NewSendMailAction.vue?vue&type=template&id=a8588ae4&scoped=true&"
import script from "./NewSendMailAction.vue?vue&type=script&lang=js&"
export * from "./NewSendMailAction.vue?vue&type=script&lang=js&"
import style0 from "./NewSendMailAction.vue?vue&type=style&index=0&id=a8588ae4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8588ae4",
  null
  
)

export default component.exports